export const getSnackbar = store => store.snackbar
